import React from 'react';
import { LucideIcon } from 'lucide-react';
import { EmailBlock } from '../types';

interface ComponentItemProps {
  type: EmailBlock['type'];
  name: string;
  icon: LucideIcon;
  description?: string;
  onDragStart: (blockType: EmailBlock['type']) => void;
  onDragEnd: () => void;
  isDarkMode: boolean;
}

export const ComponentItem: React.FC<ComponentItemProps> = ({
  type,
  name,
  icon: Icon,
  description,
  onDragStart,
  onDragEnd,
  isDarkMode
}) => {
  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.effectAllowed = 'copy';
    e.dataTransfer.setData('blockType', type);
    onDragStart(type);
  };

  const handleDragEnd = () => {
    onDragEnd();
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      className={`
        flex items-center space-x-3 p-3 rounded-lg cursor-move
        transition-colors duration-150
        ${isDarkMode 
          ? 'bg-gray-700 hover:bg-gray-600 text-gray-200' 
          : 'bg-gray-50 hover:bg-gray-100 text-gray-700'
        }
        active:opacity-75
      `}
      title={description || name}
    >
      <div className={`
        flex-shrink-0 p-2 rounded
        ${isDarkMode ? 'bg-gray-800' : 'bg-white'}
      `}>
        <Icon className="w-4 h-4" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium truncate">{name}</div>
        {description && (
          <div className={`text-xs truncate ${
            isDarkMode ? 'text-gray-400' : 'text-gray-500'
          }`}>
            {description}
          </div>
        )}
      </div>
    </div>
  );
};
